import { Directive, DOCUMENT, ElementRef, inject } from '@angular/core';

@Directive({
    selector: '[appTrapFocus]',
    standalone: true,
    host: {
        '(keydown.Tab)': 'onTabKeydown($event)',
        '(keydown.shift.Tab)': 'onShiftTabKeydown($event)',
    },
})
export class TrapFocusDirective {
    private elementRef = inject(ElementRef);
    private document = inject(DOCUMENT);

    onTabKeydown(event: Event): void {
        if (this.trapFocus('forward')) {
            event.preventDefault();
        }
    }

    onShiftTabKeydown(event: Event): void {
        if (this.trapFocus('backward')) {
            event.preventDefault();
        }
    }

    private trapFocus(direction: 'forward' | 'backward'): boolean {
        const focusableElements = this.elementRef.nativeElement.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), details, [tabindex]:not([tabindex="-1"])',
        );

        const focusableArray = <HTMLElement[]>Array.from(focusableElements);
        const firstFocusable = focusableArray[0];
        const lastFocusable = focusableArray[focusableArray.length - 1];
        const activeElement = <HTMLElement>this.document.activeElement;

        if (activeElement === lastFocusable && direction === 'forward') {
            firstFocusable?.focus();
            return true;
        }

        if (activeElement === firstFocusable && direction === 'backward') {
            lastFocusable?.focus();
            return true;
        }

        return false;
    }
}
